import { put, call, takeEvery, all, fork, select } from "redux-saga/effects";
import { actions, getters } from "./index";
import { registerError } from "redux/modules/errors/actions";
import { apiCall } from "App/Data/sagas";

const getCustomFields = function*({ preferences }) {
  try {
    const sessionId = yield select(getters.sessionId);
    const { payload } = yield call(apiCall, {
      method: "get",
      url: `/sessions/session/${sessionId}/custom-fields`,
      qs: {
        preferences
      }
    });

    return payload;
  } catch (err) {
    yield put(
      registerError([
        {
          system: err,
          user: "An error occurred getting fields"
        }
      ])
    );
  }
  return {};
};

const init = function*({ payload: { sessionId, visibleFields, fieldOrder } }) {
  try {
    yield put(actions.setLoading(true));
    yield put(actions.setSessionId(sessionId));

    const { fields, default_preferences } = yield call(getCustomFields, {
      preferences: {}
    });

    yield put(
      actions.setInitialData({
        fields: [
          {
            fields,
            id: 0,
            is_report_category: false,
            name: `Session Details`
          }
        ],
        defaultPreferences: default_preferences,
        allFields: fields,
        visibleFields,
        fieldOrder
      })
    );
  } catch (error) {
    yield all([
      put(
        registerError([
          {
            system: error,
            user: "An error occurred loading fields"
          }
        ])
      )
    ]);
  } finally {
    yield put(actions.setLoading(false));
  }
};

const refreshFields = function*() {
  try {
    const fieldOrder = yield select(getters.fieldOrder);
    const { fields, default_preferences } = yield call(getCustomFields);

    yield put(
      actions.setRefreshedFields({
        fields: [
          {
            fields,
            id: 0,
            is_report_category: false,
            name: `Session Details`
          }
        ],
        allFields: fields,
        defaultPreferences: default_preferences,
        fieldOrder
      })
    );
  } catch (error) {
    yield all([
      put(
        registerError([
          {
            system: error,
            user: "An error occurred refreshing fields"
          }
        ])
      )
    ]);
  }
};

const watchRefreshFields = function*() {
  yield takeEvery(actions.refreshFields.type, refreshFields);
};

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const rootSaga = function*() {
  yield all([fork(watchInit), fork(watchRefreshFields)]);
};

export default rootSaga;
